
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'HpInfectionEradicationCriteria',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/HpInfectionEradicationCriteria.vue